import React from "react";
import "./App.css";
import ChatWidget from "./components/ChatWidget";

function App({ tenantId, tenantSecret }) {
  // Use provided props or fallback to environment variables
  const tenantConfig = {
    tenantId: tenantId || process.env.REACT_APP_TENANT_ID,
    tenantSecret: tenantSecret || process.env.REACT_APP_TENANT_SECRET,
  };

  return (
    <div className="App">
      <ChatWidget
        tenantId={tenantConfig.tenantId}
        tenantSecret={tenantConfig.tenantSecret}
      />
    </div>
  );
}

export default App;
